/**
 * /app/$tenantSlug/me/account — Me → Account (N1). Security is the default
 * tab, so the bare URL (the sidebar item's target) lands there.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/account/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/me/account/security",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
